export const rfidTrackingDict: Record<string, [en: string, th: string]> = {
  "RfidTracking.pageTitle": ["RFID Gate Monitor", "RFID Gate Monitor"],
  "RfidTracking.breadcrumb": ["RFID Gate Monitor", "RFID Gate Monitor"],
  "RfidTracking.summary.unresolvedAlerts": ["Unauthorized Exits", "ขวดออกโดยไม่ได้อนุมัติ"],
  "RfidTracking.summary.unknownTags": ["Unknown Tags", "Tag ไม่รู้จัก"],
  "RfidTracking.summary.unverifiedCheckouts": ["Pending Gate Verification", "รอผ่าน Gate"],
  "RfidTracking.summary.overdueCheckouts": ["Checkout Follow-up", "Checkout ที่ต้องติดตาม"],
  "RfidTracking.tab.exceptions": ["Exceptions", "Exceptions"],
  "RfidTracking.tab.gateLog": ["Gate Log", "Gate Log"],
  "RfidTracking.tab.checkoutLedger": ["Bottle Listing Follow-up", "ติดตามในรายการขวด"],
  "RfidTracking.filter.allExceptionTypes": ["All gate alerts", "Gate Alert ทั้งหมด"],
  "RfidTracking.filter.overdueThresholdInDays": ["overdue threshold in days", "เกณฑ์เกินกำหนดเป็นวัน"],
  "RfidTracking.filter.from": ["From", "จาก"],
  "RfidTracking.filter.to": ["To", "ถึง"],
  "RfidTracking.filter.event": ["Event", "Event"],
  "RfidTracking.filter.result": ["Result", "ผลลัพธ์"],
  "RfidTracking.filter.resolution": ["Resolution", "สถานะการ Resolve"],
  "RfidTracking.filter.status": ["Status", "สถานะ"],
  "RfidTracking.filter.gate": ["Gate", "Gate"],
  "RfidTracking.column.type": ["Type", "ประเภท"],
  "RfidTracking.column.issue": ["Issue", "ปัญหา"],
  "RfidTracking.column.when": ["When", "เวลา"],
  "RfidTracking.column.assetTag": ["Asset / Tag", "Asset / Tag"],
  "RfidTracking.column.wine": ["Wine", "ไวน์"],
  "RfidTracking.column.readerOwner": ["Reader", "Reader"],
  "RfidTracking.column.context": ["Where / Who", "จุดเกิดเหตุ / ผู้ทำรายการ"],
  "RfidTracking.column.whenAndSource": ["Time / Source", "เวลา / ที่มา"],
  "RfidTracking.column.nextStep": ["Next Step", "สิ่งที่ควรทำ"],
  "RfidTracking.column.severity": ["Severity", "ความรุนแรง"],
  "RfidTracking.column.action": ["Action", "จัดการ"],
  "RfidTracking.column.time": ["Time", "เวลา"],
  "RfidTracking.column.event": ["Event", "Event"],
  "RfidTracking.column.tag": ["Tag", "Tag"],
  "RfidTracking.column.reader": ["Reader", "Reader"],
  "RfidTracking.column.result": ["Result", "ผลลัพธ์"],
  "RfidTracking.column.state": ["State", "สถานะ"],
  "RfidTracking.column.bottle": ["Bottle", "ขวด"],
  "RfidTracking.column.reason": ["Reason", "เหตุผล"],
  "RfidTracking.column.checkedOut": ["Checked Out", "Checkout เมื่อ"],
  "RfidTracking.column.closed": ["Closed", "ปิดเมื่อ"],
  "RfidTracking.column.gate": ["Gate", "Gate"],
  "RfidTracking.exception.unauthorizedExit": ["Unapproved movement", "ขวดออกโดยไม่ได้อนุมัติ"],
  "RfidTracking.exception.unknownTag": ["Unknown RFID tag", "RFID Tag ไม่รู้จัก"],
  "RfidTracking.exception.checkoutNotVerified": ["Pending gate verification", "รอผ่าน Gate"],
  "RfidTracking.exception.overdueCheckout": ["Checkout follow-up", "Checkout ที่ต้องติดตาม"],
  "RfidTracking.exceptionTitle.unauthorizedExit": [
    "Bottle passed the gate without an approved movement.",
    "ขวดผ่าน Gate ออกไป โดยไม่มีรายการนำออกที่อนุมัติไว้",
  ],
  "RfidTracking.exceptionTitle.unknownTag": [
    "RFID tag is not linked to any bottle.",
    "RFID Tag นี้ยังไม่ได้ผูกกับขวดในระบบ",
  ],
  "RfidTracking.exceptionTitle.checkoutNotVerified": [
    "Bottle has been checked out and is waiting to pass the gate.",
    "ขวดถูก Checkout แล้ว และกำลังรอผ่าน Gate",
  ],
  "RfidTracking.exceptionTitle.overdueCheckout": [
    "Checkout has been open for {days} day(s) and should be followed up in Bottle Listing.",
    "Checkout เปิดค้างมาแล้ว {days} วัน ควรติดตามในหน้ารายการขวด",
  ],
  "RfidTracking.exceptionShortTitle.unauthorizedExit": [
    "Unapproved bottle movement",
    "ขวดออกโดยไม่ได้อนุมัติ",
  ],
  "RfidTracking.exceptionShortTitle.unknownTag": [
    "Unknown RFID tag detected",
    "พบ RFID Tag ที่ไม่รู้จัก",
  ],
  "RfidTracking.exceptionShortTitle.checkoutNotVerified": [
    "Waiting for gate confirmation",
    "รอผ่าน Gate",
  ],
  "RfidTracking.exceptionShortTitle.overdueCheckout": [
    "Checkout needs follow-up after {days} day(s)",
    "Checkout ต้องติดตามหลังจาก {days} วัน",
  ],
  "RfidTracking.exceptionSummary.unauthorizedExit": [
    "This needs review because inventory may no longer match the physical bottle location.",
    "ควรตรวจสอบ เพราะจำนวนในระบบอาจไม่ตรงกับตำแหน่งจริงของขวด",
  ],
  "RfidTracking.exceptionSummary.unknownTag": [
    "The reader saw a tag, but the system cannot identify which bottle it belongs to.",
    "Reader อ่านเจอ Tag แต่ระบบยังระบุไม่ได้ว่าเป็นขวดใด",
  ],
  "RfidTracking.exceptionSummary.checkoutNotVerified": [
    "This is normally part of the checkout workflow. Follow it in Bottle Listing unless a gate exception is also detected.",
    "โดยปกติเป็นขั้นตอนของ Checkout ให้ติดตามในหน้ารายการขวด ยกเว้นมี Gate Exception เกิดขึ้นด้วย",
  ],
  "RfidTracking.exceptionSummary.overdueCheckout": [
    "Follow up from Bottle Listing and close the checkout with the final result: returned, sold, lost, or unsellable.",
    "ติดตามจากหน้ารายการขวด และปิด Checkout ด้วยผลสุดท้าย เช่น คืนเข้าสต็อก ขายแล้ว สูญหาย หรือขายไม่ได้",
  ],
  "RfidTracking.gateResult.authorized": ["Authorized", "อนุมัติแล้ว"],
  "RfidTracking.gateEvent.out": ["Gate Out", "ออก Gate"],
  "RfidTracking.gateEvent.in": ["Gate In", "เข้า Gate"],
  "RfidTracking.source.gateEvent": ["RFID gate", "RFID Gate"],
  "RfidTracking.source.checkout": ["Bottle movement", "รายการนำขวดออก"],
  "RfidTracking.source.owner": ["Owner", "ผู้ทำรายการ"],
  "RfidTracking.priority.critical": ["Critical", "เร่งด่วนมาก"],
  "RfidTracking.priority.high": ["High", "สูง"],
  "RfidTracking.priority.medium": ["Medium", "ปานกลาง"],
  "RfidTracking.priority.warning": ["Warning", "แจ้งเตือน"],
  "RfidTracking.state.resolved": ["Resolved", "Resolved"],
  "RfidTracking.state.unresolved": ["Unresolved", "Unresolved"],
  "RfidTracking.state.open": ["Open", "Open"],
  "RfidTracking.status.active": ["Active", "Active"],
  "RfidTracking.status.closed": ["Closed", "Closed"],
  "RfidTracking.status.verified": ["Verified", "Verified"],
  "RfidTracking.status.notVerified": ["Not verified", "Not verified"],
  "RfidTracking.status.out": ["out", "out"],
  "RfidTracking.action.resolveAlert": ["Resolve alert", "ปิด Alert นี้"],
  "RfidTracking.action.completeCheckout": ["Close movement", "ปิดรายการนำออก"],
  "RfidTracking.action.resolve": ["Resolve", "Resolve"],
  "RfidTracking.action.closeMovement": ["Close", "ปิดรายการ"],
  "RfidTracking.totalExceptions": ["Total exceptions: {total}", "Exceptions ทั้งหมด: {total}"],
  "RfidTracking.emptyExceptions": ["No exceptions need action.", "ไม่มี Exception ที่ต้องจัดการ"],
  "RfidTracking.ageDaysAgo": ["{days}d ago", "{days} วันที่แล้ว"],
  "RfidTracking.checkedOutDays": ["Checked out {days} day(s)", "Checkout มาแล้ว {days} วัน"],
  "RfidTracking.noLocation": ["No location", "ไม่ระบุตำแหน่ง"],
  "RfidTracking.checkout": ["Movement", "รายการนำออก"],
  "RfidTracking.checkoutContext": ["Taken out for: {reason}", "นำออกเพื่อ: {reason}"],
  "RfidTracking.bottle.unknownTag": ["Unknown RFID tag", "RFID Tag ไม่รู้จัก"],
  "RfidTracking.bottle.unknownBottle": ["Unknown bottle", "ไม่พบข้อมูลขวด"],
  "RfidTracking.bottle.assetNo": ["Asset No.: {asset_no}", "Asset No.: {asset_no}"],
  "RfidTracking.bottle.rfidNo": ["RFID No.: {rfid_no}", "RFID No.: {rfid_no}"],
  "RfidTracking.bottle.assetWithRfid": ["Asset No.: {asset_no} | RFID: {rfid_no}", "Asset No.: {asset_no} | RFID: {rfid_no}"],
  "RfidTracking.bottle.noIdentifier": ["No asset or RFID number", "ไม่มี Asset No. หรือ RFID No."],
  "RfidTracking.nextStep.unauthorizedExit": [
    "Confirm where the bottle is now. If the movement is valid, create or correct the movement record, then resolve this alert.",
    "ยืนยันว่าขวดอยู่ที่ไหนตอนนี้ ถ้าการนำออกถูกต้อง ให้สร้างหรือแก้ไขรายการนำออก แล้ว Resolve Alert นี้",
  ],
  "RfidTracking.nextStep.unknownTag": [
    "Check the physical tag. Link it to the correct bottle, or remove the tag from use.",
    "ตรวจ Tag จริง แล้วผูกกับขวดที่ถูกต้อง หรือถอด Tag นี้ออกจากการใช้งาน",
  ],
  "RfidTracking.nextStep.checkoutNotVerified": [
    "Wait for the bottle to pass the gate, or follow up from Bottle Listing. It is not a gate alert by itself.",
    "รอให้ขวดผ่าน Gate หรือติดตามจากหน้ารายการขวด รายการนี้ไม่ใช่ Gate Alert ด้วยตัวเอง",
  ],
  "RfidTracking.nextStep.overdueCheckout": [
    "Follow up in Bottle Listing. Close the checkout as returned, sold, lost, or unsellable.",
    "ติดตามในหน้ารายการขวด แล้วปิด Checkout เป็น คืนเข้าสต็อก ขายแล้ว สูญหาย หรือขายไม่ได้",
  ],
  "RfidTracking.nextStep.review": ["Review this exception.", "ตรวจสอบรายการนี้"],
  "RfidTracking.confirm": ["Confirm", "ยืนยัน"],
  "RfidTracking.done": ["Done", "สำเร็จ"],
  "RfidTracking.result.consumedDamaged": ["Consumed / Damaged", "ใช้แล้ว / เสียหาย"],
  "RfidTracking.complete.title": ["Complete Checkout", "ปิด Checkout"],
  "RfidTracking.complete.unverifiedWarning": [
    "This checkout has not been verified by the RFID gate.",
    "Checkout นี้ยังไม่ผ่านการยืนยันจาก RFID Gate",
  ],
  "RfidTracking.complete.checkoutResult": ["Checkout Result", "ผลลัพธ์ Checkout"],
  "RfidTracking.complete.completedUnverified": ["Completed without gate verification", "ปิดรายการโดยยังไม่ผ่าน Gate"],
  "RfidTracking.complete.failed": ["Failed to complete checkout", "ปิด Checkout ไม่สำเร็จ"],
  "RfidTracking.resolve.title": ["Resolve Gate Alert", "Resolve Gate Alert"],
  "RfidTracking.resolve.note": ["Resolution Note", "หมายเหตุการ Resolve"],
  "RfidTracking.resolve.notePlaceholder": ["Explain how the alert was resolved", "อธิบายวิธีจัดการ Alert นี้"],
  "RfidTracking.resolve.submit": ["Resolve", "Resolve"],
  "RfidTracking.resolve.failed": ["Failed to resolve", "Resolve ไม่สำเร็จ"],
  "RfidTracking.infoButton": ["Show report explanation", "ดูคำอธิบายรายงาน"],
  "RfidTracking.infoTitle": ["RFID report guide", "คำอธิบายรายงาน RFID"],
  "RfidTracking.infoIntro": [
    "This page is for RFID gate monitoring. It shows gate-detected alerts and reader history. Normal checkout follow-up stays in Bottle Listing.",
    "หน้านี้ใช้ติดตาม RFID Gate โดยแสดง Alert ที่เกิดจาก Gate และประวัติ Reader ส่วน Checkout ปกติให้ติดตามในหน้ารายการขวด",
  ],
  "RfidTracking.infoExceptionsTitle": ["Gate alerts", "Gate Alerts"],
  "RfidTracking.infoExceptionsBody": [
    "Shows only gate-detected problems that need action, such as unauthorized exits and unknown RFID tags.",
    "แสดงเฉพาะปัญหาที่ Gate ตรวจพบและต้องจัดการ เช่น ขวดออกโดยไม่ได้อนุมัติ และ RFID Tag ที่ไม่รู้จัก",
  ],
  "RfidTracking.infoGateLogTitle": ["Gate Log", "Gate Log"],
  "RfidTracking.infoGateLogBody": [
    "Shows raw RFID reader events for investigation: time, gate direction, tag, reader, result, and resolution state. It is not the checkout status list.",
    "แสดง event ดิบจาก RFID reader เพื่อใช้ตรวจสอบย้อนหลัง เช่น เวลา ทิศทาง gate tag reader ผลลัพธ์ และสถานะการ resolve ไม่ใช่หน้าสถานะ Checkout",
  ],
  "RfidTracking.infoCheckoutLedgerTitle": ["Bottle Listing Follow-up", "ติดตามในรายการขวด"],
  "RfidTracking.infoCheckoutLedgerBody": [
    "Checkout and return work is handled in Bottle Listing. RFID Tracking only links to those records when follow-up is needed.",
    "การ Checkout และ Return จัดการในหน้ารายการขวด หน้า RFID Tracking จะแค่เชื่อมไปเมื่อต้องติดตาม",
  ],
  "RfidTracking.infoSummaryTitle": ["Status counters", "ตัวเลขสถานะ"],
  "RfidTracking.infoSummaryBody": [
    "Unauthorized Exits and Unknown Tags are gate problems. Checkout overdue means an open checkout has not been finalized and has not been verified by the gate for 1+ day by default.",
    "Unauthorized Exits และ Unknown Tags คือปัญหาจาก Gate ส่วน Checkout เกินกำหนดหมายถึงรายการ Checkout ที่ยังไม่ปิด และยังไม่ผ่าน Gate ตั้งแต่ 1 วันขึ้นไปเป็นค่าเริ่มต้น",
  ],
  "RfidTracking.close": ["Close", "ปิด"],

  // ── Page header ────────────────────────────────────────
  "RfidTracking.subtitle": [
    "Monitor RFID gate events. Gate alerts need action; pending checkouts are handled in Bottle Listing.",
    "ติดตามเหตุการณ์ RFID Gate โดย Alert จาก Gate ต้องจัดการ ส่วน Checkout ที่รออยู่ให้ติดตามในหน้ารายการขวด",
  ],
  "RfidTracking.header.checkouts": ["Checkouts", "รายการนำออก"],
  "RfidTracking.header.stock": ["Stock", "สต็อก"],
  "RfidTracking.refresh": ["Refresh", "รีเฟรช"],

  // ── Latest gate event band ─────────────────────────────
  "RfidTracking.latest.title": ["Latest gate event", "เหตุการณ์ Gate ล่าสุด"],
  "RfidTracking.latest.empty": ["No gate log found.", "ไม่พบข้อมูล Gate Log"],
  "RfidTracking.latest.assetTag": ["Asset / Tag", "Asset / Tag"],
  "RfidTracking.latest.reader": ["Reader", "Reader"],
  "RfidTracking.latest.location": ["Location", "ตำแหน่ง"],
  "RfidTracking.latest.stateLabel": ["State", "สถานะ"],
  "RfidTracking.latest.state.resolved": ["resolved", "ปิดแล้ว"],
  "RfidTracking.latest.state.openAlert": ["open alert", "Alert ที่เปิดอยู่"],
  "RfidTracking.latest.state.normal": ["normal", "ปกติ"],

  // ── Metric counters ────────────────────────────────────
  "RfidTracking.metric.unauthorizedExits": ["Unauthorized exits", "ขวดออกโดยไม่ได้อนุมัติ"],
  "RfidTracking.metric.unknownTags": ["Unknown tags", "Tag ไม่รู้จัก"],
  "RfidTracking.metric.pendingGate": ["Pending gate", "รอผ่าน Gate"],
  "RfidTracking.metric.normalCheckoutFlow": [
    "normal checkout flow",
    "ขั้นตอน Checkout ปกติ",
  ],
  "RfidTracking.metric.checkoutOverdue": ["Checkout overdue", "Checkout เกินกำหนด"],
  "RfidTracking.metric.checkoutFollowUp": [
    "checkout follow-up",
    "ติดตาม Checkout",
  ],
  "RfidTracking.metric.checkoutOverdueRule": [
    "open + not gate-verified for {days}+ day(s)",
    "เปิดค้าง + ยังไม่ผ่าน Gate ตั้งแต่ {days} วันขึ้นไป",
  ],

  // ── Main exceptions panel ─────────────────────────────
  "RfidTracking.exceptions.title": ["Gate alerts that need action", "Gate Alert ที่ต้องจัดการ"],
  "RfidTracking.exceptions.subtitle": [
    "Only gate-detected exceptions appear here. Pending checkouts stay in Bottle Listing until they become an actual gate problem.",
    "แสดงเฉพาะ Exception ที่เกิดจาก Gate เท่านั้น ส่วน Checkout ที่รออยู่ให้ติดตามในหน้ารายการขวด จนกว่าจะกลายเป็นปัญหาจาก Gate",
  ],
  "RfidTracking.exceptions.filterPlaceholder": [
    "Gate alert type",
    "ประเภท Gate Alert",
  ],
  "RfidTracking.exceptions.option.all": ["All gate alerts", "Gate Alert ทั้งหมด"],
  "RfidTracking.exceptions.option.unauthorizedExit": [
    "Unauthorized exit",
    "ขวดออกโดยไม่ได้อนุมัติ",
  ],
  "RfidTracking.exceptions.option.unknownTag": ["Unknown tag", "Tag ไม่รู้จัก"],
  "RfidTracking.exceptions.column.problem": ["Problem", "ปัญหา"],
  "RfidTracking.exceptions.column.when": ["When", "เวลา"],
  "RfidTracking.exceptions.column.assetTag": ["Asset / Tag", "Asset / Tag"],
  "RfidTracking.exceptions.column.wine": ["Wine", "ไวน์"],
  "RfidTracking.exceptions.column.reader": ["Reader", "Reader"],
  "RfidTracking.exceptions.column.priority": ["Priority", "ความสำคัญ"],
  "RfidTracking.exceptions.column.action": ["Action", "จัดการ"],
  "RfidTracking.exceptions.resolveTooltip": [
    "Resolve gate alert",
    "Resolve Gate Alert นี้",
  ],
  "RfidTracking.exceptions.totalGateAlerts": [
    "Total gate alerts: {total}",
    "Gate Alert ทั้งหมด: {total}",
  ],

  // ── Gate log collapse ──────────────────────────────────
  "RfidTracking.gateLog.title": ["Gate log history", "ประวัติ Gate Log"],
  "RfidTracking.gateLog.subtitle": [
    "Raw reader events for investigation. This is not the checkout status list.",
    "Event ดิบจาก Reader เพื่อใช้ตรวจสอบย้อนหลัง ไม่ใช่หน้าสถานะ Checkout",
  ],
  "RfidTracking.gateLog.filter.from": ["From", "จาก"],
  "RfidTracking.gateLog.filter.to": ["To", "ถึง"],
  "RfidTracking.gateLog.filter.eventPlaceholder": ["Event", "Event"],
  "RfidTracking.gateLog.filter.resultPlaceholder": ["Result", "ผลลัพธ์"],
  "RfidTracking.gateLog.filter.resolutionPlaceholder": [
    "Resolution",
    "สถานะการ Resolve",
  ],
  "RfidTracking.gateLog.event.gateOut": ["gate_out", "gate_out"],
  "RfidTracking.gateLog.event.gateIn": ["gate_in", "gate_in"],
  "RfidTracking.gateLog.result.authorized": ["Authorized", "อนุมัติแล้ว"],
  "RfidTracking.gateLog.result.unauthorizedExit": [
    "Unauthorized exit",
    "ขวดออกโดยไม่ได้อนุมัติ",
  ],
  "RfidTracking.gateLog.result.unknownTag": ["Unknown tag", "Tag ไม่รู้จัก"],
  "RfidTracking.gateLog.resolution.resolved": ["Resolved", "ปิดแล้ว"],
  "RfidTracking.gateLog.resolution.unresolved": ["Unresolved", "ยังไม่ปิด"],
  "RfidTracking.gateLog.column.time": ["Time", "เวลา"],
  "RfidTracking.gateLog.column.event": ["Event", "Event"],
  "RfidTracking.gateLog.column.tag": ["Tag", "Tag"],
  "RfidTracking.gateLog.column.reader": ["Reader", "Reader"],
  "RfidTracking.gateLog.column.result": ["Result", "ผลลัพธ์"],
  "RfidTracking.gateLog.column.state": ["State", "สถานะ"],
  "RfidTracking.gateLog.state.resolved": ["resolved", "ปิดแล้ว"],
  "RfidTracking.gateLog.state.open": ["open", "เปิดอยู่"],

  // ── Severity labels ────────────────────────────────────
  "RfidTracking.severity.critical": ["Critical", "เร่งด่วนมาก"],
  "RfidTracking.severity.high": ["High", "สูง"],
  "RfidTracking.severity.medium": ["Medium", "ปานกลาง"],
  "RfidTracking.severity.warning": ["Warning", "แจ้งเตือน"],

  // ── Exception type labels (table tag) ──────────────────
  "RfidTracking.exceptionType.unauthorizedExit": [
    "Unauthorized exit",
    "ขวดออกโดยไม่ได้อนุมัติ",
  ],
  "RfidTracking.exceptionType.unknownTag": ["Unknown tag", "Tag ไม่รู้จัก"],
  "RfidTracking.exceptionType.checkoutNotVerified": [
    "Checkout not verified",
    "Checkout ยังไม่ผ่าน Gate",
  ],
  "RfidTracking.exceptionType.overdueCheckout": [
    "Overdue checkout",
    "Checkout เกินกำหนด",
  ],

  // ── Gate result labels ─────────────────────────────────
  "RfidTracking.gateResult.unauthorizedExit": [
    "Unauthorized exit",
    "ขวดออกโดยไม่ได้อนุมัติ",
  ],
  "RfidTracking.gateResult.unknownTag": ["Unknown tag", "Tag ไม่รู้จัก"],

  // ── Resolve alert dialog ───────────────────────────────
  "RfidTracking.resolveDialog.title": ["Resolve Gate Alert", "Resolve Gate Alert"],
  "RfidTracking.resolveDialog.cancel": ["Cancel", "ยกเลิก"],
  "RfidTracking.resolveDialog.resolve": ["Resolve", "Resolve"],

  // ── Swal toasts ────────────────────────────────────────
  "RfidTracking.toast.resolved": ["Resolved", "ปิดแล้ว"],
  "RfidTracking.toast.error": ["Error", "เกิดข้อผิดพลาด"],
  "RfidTracking.toast.resolveFailed": [
    "Failed to resolve",
    "Resolve ไม่สำเร็จ",
  ],
};
